<template>
  <v-row >
    <v-col cols="12">
      <v-btn
        @click="$router.go(-1)"
        rounded
        color="secondary"
        depressed
        :block="isMobile()"
      >
        <v-icon left>mdi-arrow-left</v-icon> Voltar</v-btn
      >
    </v-col>
    <v-col cols="12">
      <v-card flat>
        <v-card-title class="font-weight-bold">Atualizar Contato</v-card-title>
        <v-card-text>
          <v-progress-linear indeterminate v-if="loading"></v-progress-linear>
          <v-card flat v-else>
            <v-row>
              <v-col xl="6" lg="6" md="6" cols="12">
                <card-contato :numContato="1" />
              </v-col>
              <v-col xl="6" lg="6" md="6" cols="12">
                <card-contato :numContato="2" />
              </v-col>
            </v-row>
          </v-card>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions } from "vuex";
import CardContato from "./components/CardContato.vue";
export default {
  components: {
    CardContato,
  },
  data: () => ({
    loading: false,
  }),
  methods: {
    ...mapActions("atualizacaoCadastral",["getDadosCadastrais"]),
    isMobile() {
      return this.$mq == "sm";
    },
  },
  async mounted() {
    this.loading = true
    await this.getDadosCadastrais();
    this.loading = false
  },
};
</script>

<style>
</style>
